import { AllCardsType } from '../../../data/all-cards'
import { DataType } from '../../../interfaces/utils'
import { formatCardLabel } from '../../../utils/card-label'

export const interpret = (cards: AllCardsType[], data: DataType, user: string, type: string) => {
    console.log('Tipo:', data.tipo)
    let consult
    if (data.tipo === '2') {
        consult = `Por favor, realiza la intepretación de la Tirada del Amor Básica de 5 cartas que realizaste para ${
            data.consultante.name
        } como consultado y ${
            data.consultado.name
        } como consultado, de la siguiente forma: 1. Energía actual del consultate: ${formatCardLabel(cards[0])}, 2. Energía del consultado: ${formatCardLabel(cards[1])}, 3. Obstáculo o bloqueo preente: ${formatCardLabel(cards[2])}, 4. Consejo del tarot: ${formatCardLabel(cards[3])}, y 5. Evolución o desenlace probable: ${formatCardLabel(cards[4])}. ${
            data.consulta.length > 0
                ? 'Ten en cuenta la consulta del consultante dentro de la interpretación: ' + data.consulta
                : ''
        } Dirígete directamente al consultante, no utilices la tercera persona refiriendote a la consultante, aún cuando las consultas se encuentren en tercera persona, adapta la respuesta para que quede en segunda persona. Incluye después de la interpretación, en un nuevo párrafo, un resúmen que aclare concretamente lo que las cartas le quieren transmitir al consultante. No utilices emoticones. No pongas títulos, solo haz una narrativa de cada aspecto de las 5 cartas.`
    } else if (data.tipo === '1') {
        consult = `Interpreta la tirada de cartas para la lectura del amor básica que realizaste para ${
            data.consultante.name
        } cómo consultante, las cartas que salieron son: ${formatCardLabel(cards[0])}, cómo energía actual del consultante; ${formatCardLabel(cards[1])}, cómo energía extrna o influencia que afecta su campo amoroso actual, ${formatCardLabel(cards[2])}, como obstáculo o bloqueo presente, ${formatCardLabel(cards[3])}, como consejo del tarot, y ${formatCardLabel(cards[4])}, como evolución o desenlace probable. ${
            data.consulta.length === 0
                ? 'Ten en cuenta en la interpretación la consulta que hace el consultante: ' + data.consulta + '.'
                : ''
        } Dirígete directamente al consultante, no utilices la tercera persona refiriendote a la consultante, aún cuando las consultas se encuentren en tercera persona, adapta la respuesta para que quede en segunda persona persona. Incluye después de la interpretación, en un nuevo párrafo, un resúmen que aclare concretamente lo que las cartas le quieren transmitir al consultante.`
    }

    let info = {
        consult: consult,
        user: user,
        clientName: data.consultante.name,
        clientPhone: data.consultante.phone || '',
        clientAnswer: data.consulta,
        cards: cards,
        type: type,
    }

    return info
}
